import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="d-sm-flex justify-content-center justify-content-sm-between">
          <span className="text-muted text-center mx-auto d-block d-sm-inline-block">
            Copyright © 2025{" "}
            <a
              href="https://dashboard.diaq.hhgs.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              AirBubble            </a>
            . All rights reserved.
          </span>
        </div>
      </footer>
    );
  }
}

export default Footer;
